export default __webpack_public_path__ + "static/media/1148.33698146.png";